import { useEffect, useState } from "react";
import axios from "axios";
import socket from "../tools/socke";
import Swal from 'sweetalert2';
import jsPDF from 'jspdf';
import ObtieneDatosCookies from "../obtieneDatosCookiesUsuario";
import * as XLSX from 'xlsx';
import regresaBienFecha from '../tools/regresaBienFecha'
import comprueboPermisos from "../tools/comprueboPermisos";
const AsistenciasCurso = ({ idCurso, division, curso, devuelvoFecha }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [mostrarPresentes, setMostrarPresentes] = useState(false);
  const [fecha, setFecha] = useState(""); // yyyy-mm-dd
  const [stats, setStats] = useState({
    presentes: 0,
    ausentes: 0,
  });
  const [dataAusentes, setDataAusentes] = useState([]); // ← Los que NO marcaron QR
  const [muestraAusentes, setMuestraAusentes] = useState(false); // ← ESTO TE FALTA
  const Usuario = ObtieneDatosCookies()
  const token = btoa(
    `${process.env.REACT_APP_KEY}:${process.env.REACT_APP_PASS}`
  );
  const descargarPDFAusentes = (cursoId, ausentes) => {
    if (!ausentes || !ausentes.length) return;

    const pdf = new jsPDF('p', 'pt', 'a4');

    const marginLeft = 40;
    let y = 40;

    const {
      fechaHoraParte,
      usuarioSigedi,
      sede,
      escuela,
    } = ausentes[0];

    // 🧾 Título
    pdf.setFontSize(18);
    pdf.text('Parte de Inasistencias', marginLeft, y);
    y += 25;

    // 📌 Datos generales
    pdf.setFontSize(11);
    pdf.text(`Curso ID: ${cursoId}`, marginLeft, y); y += 15;
    pdf.text(`Fecha del parte: ${fechaHoraParte}`, marginLeft, y); y += 15;
    pdf.text(`Usuario SIGEDI: ${usuarioSigedi}`, marginLeft, y); y += 15;
    pdf.text(`Sede: ${sede}`, marginLeft, y); y += 15;
    pdf.text(`Escuela: ${escuela}`, marginLeft, y); y += 25;

    // 📋 Encabezado tabla
    pdf.setFontSize(11);
    pdf.text('#', marginLeft, y);
    pdf.text('DNI', marginLeft + 30, y);
    pdf.text('Apellido y Nombre', marginLeft + 110, y);
    pdf.text('Observación', marginLeft + 330, y);
    y += 10;

    pdf.line(marginLeft, y, 550, y);
    y += 15;

    // 📄 Filas
    ausentes.forEach((a, index) => {
      if (y > 780) {
        pdf.addPage();
        y = 40;
      }

      pdf.text(String(index + 1), marginLeft, y);
      pdf.text(String(a.dni), marginLeft + 30, y);
      pdf.text(`${a.apellido}, ${a.nombres}`, marginLeft + 110, y);
      pdf.text(a.observacion || '-', marginLeft + 330, y, {
        maxWidth: 200,
      });

      y += 18;
    });

    pdf.save(`Parte_Ausentes_Curso_${cursoId}.pdf`);
  };
  const esHoy = !fecha;

  const getAsistenciasCurso = async () => {
    const response = await axios.post(
      "https://wwwa.isepsantafe.net.ar/expedientes/calificaciones/devuelveAsistenciasCurso",
      {
        idCurso,
        division,
        fecha: fecha || null,
      },
      {
        headers: {
          Authorization: `Basic ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    //     console.log(response.data)
    return response.data;
  };

  const fetchAsistencias = async () => {
    try {
      setLoading(true);

      const res = await getAsistenciasCurso();
      const asistencias = res.asistencias || [];

      const presentes = asistencias.filter(
        (a) => a.estado !== "Ausente"
      );
      const ausentes = asistencias.filter(
        (a) => a.estado === "Ausente"
      );

      setStats({
        presentes: presentes.length,
        ausentes: ausentes.length,
      });

      setData(presentes);
      setDataAusentes(ausentes); // ← ESTO TE FALTA
    } catch (error) {
      console.error("Error al obtener asistencias:", error);
      setData([]);
      setDataAusentes([]); // ← ESTO TAMBIÉN
      setStats({ presentes: 0, ausentes: 0 });
    } finally {
      setLoading(false);
    }
  };




  // 🔄 Fetch por curso / división / fecha
  useEffect(() => {
    if (!idCurso || !division) return;
    fetchAsistencias();
    devuelvoFecha(fecha)
  }, [idCurso, division, fecha]);

  // 🔔 SOCKET SOLO SI ES HOY
  useEffect(() => {
    if (!esHoy) return;

    const handler = (payload) => {
      //       console.log(payload)
      if (String(payload) === String(idCurso)) {
        //         console.log("Marco alguien del curso")
        fetchAsistencias();
      }
    };

    socket.on("Nueva Asistencia", handler);
    return () => socket.off("Nueva Asistencia", handler);
  }, [idCurso, esHoy]);

  if (loading) {
    return <p>Cargando asistencias...</p>;
  }
  const descargarExcelAusentes = (cursoId, ausentes) => {
    if (!ausentes || !ausentes.length) return;

    const dataExcel = ausentes.map((a, index) => ({
      '#': index + 1,
      DNI: a.dni,
      Apellido: a.apellido,
      Nombre: a.nombres,
      División: a.division || '-',
      Observación: a.observacion || '-',
      'Fecha del parte': a.fechaHoraParte,
      'Usuario SIGEDI': a.usuarioSigedi,
      Sede: a.sede,
      Escuela: a.escuela,
    }));

    const worksheet = XLSX.utils.json_to_sheet(dataExcel);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Ausentes');

    XLSX.writeFile(
      workbook,
      `Parte_Ausentes_Curso_${cursoId}.xlsx`
    );
  };
  const anulaInasistencia = async (idAsistencia, division) => {
    const { value: formValues } = await Swal.fire({
      title: '⚠️ Anular asistencia',
      html: `
      <p style="margin-bottom:10px">
        Esta acción <b>anulará la asistencia</b> del alumno.<br/>
        ¿Desea continuar?
      </p>

      <input 
        id="swal-pass" 
        type="password" 
        class="swal2-input" 
        placeholder="Contraseña del usuario"
      />

      <textarea 
        id="swal-motivo" 
        class="swal2-textarea" 
        placeholder="Motivo de la anulación"
      ></textarea>
    `,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, anular',
      cancelButtonText: 'Cancelar',
      focusConfirm: false,
      preConfirm: () => {
        const pass = document.getElementById('swal-pass').value;
        const motivo = document.getElementById('swal-motivo').value;

        if (!pass || !motivo) {
          Swal.showValidationMessage(
            'Debe ingresar la contraseña y el motivo'
          );
          return;
        }

        return { pass, motivo };
      }
    });

    // Canceló
    if (!formValues) return;

    try {
      const response = await fetch('https://wwwa.isepsantafe.net.ar/expedientes/calificaciones/desactivarAsistencia', {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          idAsistencia,
          "pass": formValues.pass,
          "usuarioId": Usuario.id,
          "motivo": formValues.motivo,
          division: division
        }),
      });

      const data = await response.json();

      if (data.ok) {
        socket.emit('DiPresente', { IdCurso: idCurso })
        Swal.fire('✅ Anulada', data.message, 'success');

      } else {
        socket.emit('DiPresente', { IdCurso: idCurso })
        Swal.fire('⚠️ Atención', data.message, 'warning');
      }

    } catch (error) {
      console.error(error);
      Swal.fire('❌ Error', 'No se pudo anular la inasistencia', 'error');
    }
  }; const fechaHoy = new Date().toLocaleDateString("sv-SE", {
    timeZone: "America/Argentina/Buenos_Aires"
  });
  const mostrarAusentes = async (cursoId, division, fecha) => {
    const fechaHoy = new Date().toLocaleDateString("sv-SE", {
      timeZone: "America/Argentina/Buenos_Aires",
    });

    const fechaSeleccionada = fecha || fechaHoy;

    try {
      // =====================================================
      // LOADING
      // =====================================================
      Swal.fire({
        title: "Buscando inasistencias...",
        html: `
        Consultando parte del
        <b>${fechaSeleccionada}</b>
      `,
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => Swal.showLoading(),
      });

      // =====================================================
      // TRAER AUSENCIAS REALMENTE GENERADAS
      // =====================================================
      const response = await axios.post(
        "https://wwwa.isepsantafe.net.ar/expedientes/calificaciones/getAusentesCursoFecha",
        {
          cursoId,
          division,
          fecha: fechaSeleccionada,
        },
        {
          headers: {
            Authorization: `Basic ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      Swal.close();

      // =====================================================
      // VALIDAR RESPUESTA
      // =====================================================
      if (!response.data?.ok) {
        return Swal.fire(
          "⚠️ Atención",
          response.data?.message ||
          "No se pudo obtener el parte de inasistencias",
          "warning"
        );
      }

      // =====================================================
      // AUSENCIAS ACTIVAS
      // =====================================================
      const ausentes = Array.isArray(response.data?.ausentes)
        ? response.data.ausentes
        : [];

      // =====================================================
      // NO HAY AUSENTES
      // =====================================================
      if (!ausentes.length) {
        return Swal.fire({
          title: "ℹ️ Sin inasistencias",
          html: `
          <div style="text-align:left; line-height:1.6;">
            <p>
              No existen inasistencias activas en el parte correspondiente a:
            </p>

            <p style="text-align:center; font-size:20px; font-weight:bold;">
              ${fechaSeleccionada}
            </p>

            <p style="margin-top:15px; font-size:13px; color:#666;">
              Las inasistencias condonadas no se incluyen en este listado.
            </p>
          </div>
        `,
          icon: "info",
        });
      }

      // =====================================================
      // DATOS DEL PRIMER REGISTRO
      // =====================================================
      const primerAusente = ausentes[0];

      const {
        fechaHoraParte,
        usuarioSigedi,
        sede,
        escuela,
      } = primerAusente;

      // =====================================================
      // ENCABEZADO
      // =====================================================
      const encabezadoHTML = `
      <div
        style="
          margin-bottom:16px;
          text-align:left;
          line-height:1.7;
          padding:12px;
          background:#f8f9fa;
          border-radius:8px;
        "
      >
        <div>
          <b>Fecha:</b>
          ${fechaSeleccionada}
        </div>

        ${fechaHoraParte
          ? `
              <div>
                <b>Fecha y hora del parte:</b>
                ${fechaHoraParte}
              </div>
            `
          : ""
        }

        <div>
          <b>Curso:</b>
          ${curso?.nombreCurso || cursoId}
        </div>

        <div>
          <b>División:</b>
          ${division}
        </div>

        ${usuarioSigedi
          ? `
              <div>
                <b>Usuario SIGEDI:</b>
                ${usuarioSigedi}
              </div>
            `
          : ""
        }

        ${sede
          ? `
              <div>
                <b>Sede:</b>
                ${sede}
              </div>
            `
          : ""
        }

        ${escuela
          ? `
              <div>
                <b>Escuela:</b>
                ${escuela}
              </div>
            `
          : ""
        }

        <div style="
          margin-top:10px;
          padding:10px;
          background:#fee2e2;
          border-radius:6px;
          text-align:center;
        ">
          <b style="font-size:18px;">
            Inasistencias activas: ${ausentes.length}
          </b>
        </div>
      </div>
    `;

      // =====================================================
      // TABLA
      // =====================================================
      const tablaHTML = `
      <div style="
        max-height:55vh;
        overflow-y:auto;
        border:1px solid #ddd;
        border-radius:8px;
      ">
        <table style="
          width:100%;
          border-collapse:collapse;
          font-size:14px;
        ">
          <thead
            style="
              position:sticky;
              top:0;
              background:#f1f1f1;
              z-index:1;
            "
          >
            <tr style="border-bottom:2px solid #444;">
              <th style="padding:8px;">#</th>
              <th style="padding:8px;">DNI</th>
              <th style="padding:8px;">Apellido y Nombre</th>
              <th style="padding:8px;">División</th>
              <th style="padding:8px;">Tipo</th>
              <th style="padding:8px;">Observación</th>
            </tr>
          </thead>

          <tbody>
            ${ausentes
          .map(
            (a, index) => `
                  <tr style="border-bottom:1px solid #ddd;">
                    <td style="padding:8px; text-align:center;">
                      ${index + 1}
                    </td>

                    <td style="padding:8px;">
                      ${a.dni || a.alumnoDni || "-"}
                    </td>

                    <td style="padding:8px;">
                      ${a.apellido || ""}
                      ${a.apellido || a.nombres ? ", " : ""}
                      ${a.nombres || ""}
                    </td>

                    <td style="padding:8px; text-align:center;">
                      ${a.division || division || "-"}
                    </td>

                    <td style="padding:8px; text-align:center;">
                      ${a.esEntera ? "Falta completa" : "Media falta"}
                    </td>

                    <td style="padding:8px;">
                      ${a.observacion || "-"}
                    </td>
                  </tr>
                `
          )
          .join("")}
          </tbody>
        </table>
      </div>
    `;

      // =====================================================
      // SWEET ALERT
      // =====================================================
      const result = await Swal.fire({
        title: "📋 Parte de Inasistencias",
        html: encabezadoHTML + tablaHTML,
        width: "950px",
        showCloseButton: true,
        showConfirmButton: true,
        confirmButtonText: "Cerrar",
        showDenyButton: true,
        denyButtonText: "📄 PDF",
        showCancelButton: true,
        cancelButtonText: "📊 Excel",
        focusConfirm: false,
      });

      // =====================================================
      // PDF
      // =====================================================
      if (result.isDenied) {
        descargarPDFAusentes(cursoId, ausentes);
      }

      // =====================================================
      // EXCEL
      // =====================================================
      if (result.dismiss === Swal.DismissReason.cancel) {
        descargarExcelAusentes(cursoId, ausentes);
      }
    } catch (error) {
      Swal.close();

      console.error(
        "❌ Error obteniendo ausentes:",
        error.response?.data || error
      );

      Swal.fire(
        "❌ Error",
        error.response?.data?.message ||
        "No se pudo obtener el listado de ausentes",
        "error"
      );
    }
  };

  const descargarPDFPresentes = () => {


    const pdf = new jsPDF('p', 'pt', 'a4');

    const marginLeft = 40;
    let y = 40;

    const {

      usuarioSigedi,
      sede,
      escuela,
    } = data[0];

    pdf.setFontSize(18);
    pdf.text('Parte de Asistencias – Presentes', marginLeft, y);
    y += 25;

    pdf.setFontSize(11);
    pdf.text(`Curso: ${curso.nombreCurso}`, marginLeft, y); y += 15;
    pdf.text(`Fecha: ${fecha || fechaHoy}`, marginLeft, y); y += 15;
    pdf.text(`Usuario Generó: ${Usuario.apellido + ", " + Usuario.nombre}`, marginLeft, y); y += 15;
    pdf.text(`Sede: ${curso.sede || '-'}`, marginLeft, y); y += 15;
    pdf.text(`Escuela: ${curso.escuela || '-'}`, marginLeft, y); y += 25;

    // Encabezado tabla
    pdf.text('#', marginLeft, y);
    pdf.text('DNI', marginLeft + 30, y);
    pdf.text('Apellido y Nombre', marginLeft + 110, y);
    pdf.text('Hora', marginLeft + 360, y);
    y += 10;

    pdf.line(marginLeft, y, 550, y);
    y += 15;

    data.forEach((a, index) => {
      if (y > 780) {
        pdf.addPage();
        y = 40;
      }

      pdf.text(String(index + 1), marginLeft, y);
      pdf.text(String(a.alumnoDni), marginLeft + 30, y);
      pdf.text(`${a.apellido}, ${a.nombres}`, marginLeft + 110, y);
      pdf.text(a.hora || '-', marginLeft + 360, y);

      y += 18;
    });

    pdf.save(`Parte_Presentes_Curso_${curso.id}.pdf`);
  };
  const condonarInasistencias = async () => {
    try {
      // =====================================================
      // 1. TRAER INASISTENCIAS ACTIVAS DEL CURSO
      // =====================================================

      Swal.fire({
        title: "Cargando inasistencias...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => Swal.showLoading(),
      });

      const response = await axios.post(
        "https://wwwa.isepsantafe.net.ar/expedientes/calificaciones/getInasistenciasCondonables",
        {
          cursoId: idCurso,
          division,
        },
        {
          headers: {
            Authorization: `Basic ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      console.log("RESPUESTA INASISTENCIAS:", response.data);
      Swal.close();

      const resultado = response.data;

      if (!resultado?.ok) {
        return Swal.fire(
          "Atención",
          resultado?.message || "No se pudieron obtener las inasistencias",
          "warning"
        );
      }

      const inasistencias = Array.isArray(resultado.inasistencias)
        ? resultado.inasistencias
        : [];

      if (!inasistencias.length) {
        return Swal.fire(
          "Información",
          "No hay inasistencias activas para condonar",
          "info"
        );
      }

      // =====================================================
      // 2. AGRUPAR POR ALUMNO
      // =====================================================

      const alumnosMap = {};

      inasistencias.forEach((item) => {
        const dni = String(item.alumnoDni);

        if (!alumnosMap[dni]) {
          alumnosMap[dni] = {
            dni,
            apellido: item.apellido || "",
            nombres: item.nombres || "",
            inasistencias: [],
          };
        }

        alumnosMap[dni].inasistencias.push(item);
      });

      const alumnosCondonables = Object.values(alumnosMap);

      // =====================================================
      // 3. SELECCIONAR CURSANTE
      // =====================================================

      const opcionesAlumnos = {};

      alumnosCondonables
        .sort((a, b) =>
          `${a.apellido} ${a.nombres}`.localeCompare(
            `${b.apellido} ${b.nombres}`
          )
        )
        .forEach((alumno) => {
          opcionesAlumnos[alumno.dni] =
            `${alumno.apellido}, ${alumno.nombres} - DNI ${alumno.dni}`;
        });

      const seleccionAlumno = await Swal.fire({
        title: "Condonar inasistencias",
        text: "Seleccioná el cursante",
        input: "select",
        inputOptions: opcionesAlumnos,
        inputPlaceholder: "Seleccionar alumno",
        showCancelButton: true,
        confirmButtonText: "Continuar",
        cancelButtonText: "Cancelar",
        inputValidator: (value) => {
          if (!value) {
            return "Debés seleccionar un cursante";
          }
        },
      });

      if (!seleccionAlumno.isConfirmed) return;

      const alumnoSeleccionado =
        alumnosMap[String(seleccionAlumno.value)];

      if (!alumnoSeleccionado) return;

      // =====================================================
      // 4. SELECCIONAR INASISTENCIAS
      // =====================================================

      const filas = alumnoSeleccionado.inasistencias
        .sort((a, b) => String(a.fecha).localeCompare(String(b.fecha)))
        .map(
          (item) => `
          <label
            style="
              display:flex;
              align-items:center;
              gap:10px;
              padding:10px;
              margin-bottom:6px;
              border:1px solid #ddd;
              border-radius:7px;
              cursor:pointer;
              text-align:left;
            "
          >
            <input
              type="checkbox"
              class="swal-inasistencia"
              value="${item.id}"
            />

            <div>
              <b>${item.fecha}</b><br>

              <span style="font-size:13px;">
                ${item.observacion || "Sin observación"}
              </span>
            </div>
          </label>
        `
        )
        .join("");

      const seleccionInasistencias = await Swal.fire({
        title: `${alumnoSeleccionado.apellido}, ${alumnoSeleccionado.nombres}`,

        html: `
        <div style="text-align:left">

          <p>
            DNI:
            <b>${alumnoSeleccionado.dni}</b>
          </p>

          <p>
            Seleccioná las inasistencias que querés condonar:
          </p>

          <div style="
            max-height:350px;
            overflow-y:auto;
            margin-top:10px;
          ">
            ${filas}
          </div>

        </div>
      `,

        width: "700px",

        showCancelButton: true,

        confirmButtonText: "Continuar",
        cancelButtonText: "Cancelar",

        preConfirm: () => {
          const seleccionadas = Array.from(
            document.querySelectorAll(
              ".swal-inasistencia:checked"
            )
          ).map((input) => Number(input.value));

          if (!seleccionadas.length) {
            Swal.showValidationMessage(
              "Debés seleccionar al menos una inasistencia"
            );

            return false;
          }

          return seleccionadas;
        },
      });

      if (!seleccionInasistencias.isConfirmed) return;

      const idsSeleccionados =
        seleccionInasistencias.value;

      // =====================================================
      // 5. PEDIR MOTIVO
      // =====================================================

      const motivoRespuesta = await Swal.fire({
        title: "Motivo de la condonación",

        html: `
        <p>
          Vas a condonar
          <b>${idsSeleccionados.length}</b>
          ${idsSeleccionados.length === 1
            ? "inasistencia"
            : "inasistencias"
          }.
        </p>
      `,

        input: "textarea",

        inputLabel:
          "Indicá el motivo por el cual se condonan las inasistencias",

        inputPlaceholder:
          "Ej.: autorizado por resolución, justificación administrativa...",

        inputAttributes: {
          maxlength: "1000",
        },

        showCancelButton: true,

        confirmButtonText: "Continuar",
        cancelButtonText: "Cancelar",

        inputValidator: (value) => {
          if (!value || !value.trim()) {
            return "El motivo es obligatorio";
          }

          if (value.trim().length < 5) {
            return "Ingresá un motivo más descriptivo";
          }
        },
      });

      if (!motivoRespuesta.isConfirmed) return;

      const motivo =
        motivoRespuesta.value.trim();

      // =====================================================
      // 6. CONFIRMACIÓN FINAL
      // =====================================================

      const confirmar = await Swal.fire({
        title: "⚠️ Confirmar condonación",

        html: `
        <div style="text-align:left; line-height:1.7">

          <p>
            Alumno:
            <b>
              ${alumnoSeleccionado.apellido},
              ${alumnoSeleccionado.nombres}
            </b>
          </p>

          <p>
            DNI:
            <b>${alumnoSeleccionado.dni}</b>
          </p>

          <p>
            Inasistencias a condonar:
            <b>${idsSeleccionados.length}</b>
          </p>

          <hr>

          <p>
            <b>Motivo:</b><br>
            ${motivo}
          </p>

          <hr>

          <p>
            Las inasistencias seleccionadas pasarán a estado
            <b>Inactivo</b>.
          </p>

        </div>
      `,

        icon: "warning",

        showCancelButton: true,

        confirmButtonText:
          `Sí, condonar ${idsSeleccionados.length}`,

        cancelButtonText: "Cancelar",

        confirmButtonColor: "#d33",
      });

      if (!confirmar.isConfirmed) return;

      // =====================================================
      // 7. ENVIAR AL BACKEND
      // =====================================================

      Swal.fire({
        title: "Condonando inasistencias...",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => Swal.showLoading(),
      });

      const respuesta = await axios.post(
        "https://wwwa.isepsantafe.net.ar/expedientes/calificaciones/condonarInasistencias",
        {
          idsInasistencias: idsSeleccionados,
          alumnoDni: alumnoSeleccionado.dni,
          cursoId: idCurso,
          division,
          motivo,
          usuarioSigedi: Usuario.identificacion,
        },
        {
          headers: {
            Authorization: `Basic ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      Swal.close();

      if (!respuesta.data?.ok) {
        return Swal.fire(
          "Atención",
          respuesta.data?.message ||
          "No se pudieron condonar las inasistencias",
          "warning"
        );
      }

      // =====================================================
      // 8. RESULTADO
      // =====================================================

      await Swal.fire({
        title: "✅ Inasistencias condonadas",

        html: `
        <div style="text-align:left; line-height:1.7">

          <p>
            Alumno:
            <b>
              ${alumnoSeleccionado.apellido},
              ${alumnoSeleccionado.nombres}
            </b>
          </p>

          <p>
            Inasistencias condonadas:
            <b>${respuesta.data.condonadas}</b>
          </p>

        </div>
      `,

        icon: "success",
      });

      fetchAsistencias();

    } catch (error) {
      Swal.close();

      console.error(
        "Error condonando inasistencias:",
        error.response?.data || error
      );

      Swal.fire(
        "Error",
        error.response?.data?.message ||
        "No se pudieron condonar las inasistencias",
        "error"
      );
    }
  };

  const descargarExcelPresentes = () => {


    const dataExcel = data.map((a, index) => ({
      '#': index + 1,
      DNI: a.alumnoDni,
      Apellido: a.apellido,
      Nombre: a.nombres,
      Hora: a.hora || '-',
    }));

    const worksheet = XLSX.utils.json_to_sheet(dataExcel);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Presentes');

    XLSX.writeFile(
      workbook,
      `Parte_Presentes_Curso_${curso.id}.xlsx`
    );
  };
  const hoy = new Date().toISOString().split("T")[0];
  return (
    <div className="mc-wrapper">

      {/* HEADER */}
      <div className="mc-header-row">
        <div className="mc-fecha-box">
          <label>Fecha</label>
          <input
            type="date"
            value={fecha}
            max={hoy}
            onChange={(e) => setFecha(e.target.value)}
          />

          {fecha && (
            <button
              className=" btn btn-primary"
              onClick={() => setFecha("")}
            >
              Hoy
            </button>
          )}
        </div>

        <div
          className={`mc-badge-mode ${esHoy ? "live" : "history"}`}
        >
          {esHoy ? "🟢 Hoy – tiempo real" : "🔵 Fecha histórica"}
        </div>
      </div>

      {/* STATS */}
      <div className="tac-tabla-wrapper">
        <div className="mc-stat mc-stat-success">
          <span className="mc-stat-number">{stats.presentes}</span>
          <span className="mc-stat-label"> Marcaron QR</span>
        </div>

        <div className="mc-stat mc-stat-danger">
          <span className="mc-stat-number">{stats.ausentes}</span>
          <span className="mc-stat-label"> NO marcaron</span>
        </div>
      </div>

      <div style={{ textAlign: "center" }}></div>

      <button
        className="btn btn-outline-success"
        onClick={() => mostrarAusentes(idCurso, division, fecha)}
      >
        Ver Ausentes en Parte ya Generado
      </button>

      <button
        className="btn btn-success"
        onClick={() => {
          setMostrarPresentes(!mostrarPresentes);
          setMuestraAusentes(false);
        }}
      >
        Marcaron QR
      </button>

      <button
        className="btn btn-warning"
        onClick={() => {
          setMuestraAusentes(!muestraAusentes);
          setMostrarPresentes(false);
        }}
      >
        No marcaron QR
      </button>

      {comprueboPermisos(Usuario.funcion, 'Condono Inasistencias') && (
        <button
          className="btn btn-outline-danger"
          onClick={condonarInasistencias}
        >
          ✓ Condonar inasistencias
        </button>
      )}

      {/* ========================================================== */}
      {/* TABLA PRESENTES - MARCARON QR */}
      {/* ========================================================== */}
      {mostrarPresentes && (
        <div className="tac-tabla-wrapper">
          <h5>
            Presentes Registrados {esHoy ? "🟢 Hoy – tiempo real" : "🔵 " + regresaBienFecha(fecha)}
          </h5>

          <table className="tac-tabla">
            <thead>
              <tr>
                <th>#</th>
                <th>DNI</th>
                <th>Apellido</th>
                <th>Nombre</th>
                <th>División</th>
                <th>Hora</th>
              </tr>
            </thead>

            <tbody>
              {data.map((a, index) => (
                <tr
                  key={a.alumnoDni}
                  onClick={() => anulaInasistencia(a.idAsistencia, division)}
                >
                  <td>{index + 1}</td>
                  <td>{a.alumnoDni}</td>
                  <td>{a.apellido}</td>
                  <td>{a.nombres}</td>
                  <td>{a.division || '-'}</td>
                  <td>{a.hora || "-"}</td>
                </tr>
              ))}

              {!data.length && (
                <tr>
                  <td colSpan="6" className="mc-empty">
                    No hay alumnos presentes en la fecha solicitada
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          {data.length > 0 && (
            <button onClick={() => descargarExcelPresentes()}>
              Descargar en Excel
            </button>
          )}
        </div>
      )}

      {/* ========================================================== */}
      {/* TABLA AUSENTES - NO MARCARON QR */}
      {/* ========================================================== */}
      {muestraAusentes && (
        <div className="tac-tabla-wrapper">
          <h5>
            No registrados
            {" "}
            {esHoy
              ? "🟢 Hoy – tiempo real"
              : "🔵 " + regresaBienFecha(fecha)}
          </h5>

          <table className="tac-tabla">
            <thead>
              <tr>
                <th>#</th>
                <th>DNI</th>
                <th>Apellido</th>
                <th>Nombre</th>
                <th>División</th>
                <th>Estado</th>
              </tr>
            </thead>

            <tbody>
              {dataAusentes.map((a, index) => (
                <tr key={a.alumnoDni || index}>
                  <td>{index + 1}</td>
                  <td>{a.alumnoDni || a.dni}</td>
                  <td>{a.apellido}</td>
                  <td>{a.nombres}</td>
                  <td>{a.division || "-"}</td>
                  <td>Ausente</td>
                </tr>
              ))}

              {!dataAusentes.length && (
                <tr>
                  <td colSpan="6" className="mc-empty">
                    No hay alumnos ausentes en la fecha solicitada
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          {dataAusentes.length > 0 && (
            <div style={{ marginTop: "10px" }}>
              <button
                onClick={() => descargarExcelAusentes(idCurso, dataAusentes)}
              >
                Descargar en Excel
              </button>
            </div>
          )}
        </div>
      )}

    </div>
  );
};

export default AsistenciasCurso;